import React, { Component } from 'react';
import propTypes from 'prop-types';

import { DragSource } from 'react-dnd';
import { calculateTextColor } from '~/Context/Color';
import { onlyTime } from '~/Components/Global/CalendarEvents/FormatDateTime';
import { MONTH_EVENT } from '~/Config/DragTypes';
import { findCalendarInList } from '~/Redux/Modules/CalendarAccounts';
import { eventFontSizeHelper } from '~/Components/Global/FontWrapper/FontWrapper';

import './StyledEvent.scss';

const eventDrag = {
  canDrag: ({ isDeleting }) => {
    return !isDeleting;
  },
  beginDrag: ({ event }) => {
    return {
      event: { ...event },
    };
  },
  endDrag: ({ clearEvent }) => {
    clearEvent();
  },
};

const dragCollect = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

@DragSource(MONTH_EVENT, eventDrag, dragCollect)
export default class StyledEvent extends Component {
  handleOnClick = e => {
    e.stopPropagation();
    if (this.props.clickBehavior) {
      return this.props.clickBehavior();
    }
    this.props.setCurrentEvent(this.props.event);
  };

  render() {
    const {
      event,
      style,
      showSummary,
      connectDragSource,
      isDragging,
      calendars,
      fontNameForEvents,
    } = this.props;
    const calendar = findCalendarInList(calendars, event.calendar_id);
    const color =
      event.color ||
      (event.calendar && event.calendar.color) ||
      (calendar && calendar.color) ||
      '#000000';
    let eventStyle = {
      color: event.isAllDay || event.multiDayTimed ? calculateTextColor(color) : color,
      ...style,
      fontFamily: fontNameForEvents,
    };
    const spanStyle = {
      fontSize: eventFontSizeHelper(fontNameForEvents),
      ...(eventFontSizeHelper(fontNameForEvents) == '1em' ? {} : { lineHeight: 1 }),
    };

    const className =
      event.isAllDay || event.multiDayTimed
        ? `styled-event all-day ${this.props.className} ${
            isDragging ? 'dragging' : ''
          } font-${fontNameForEvents.replace(/\s/g, '-')}`
        : `styled-event ${this.props.className} ${
            isDragging ? 'dragging' : ''
          } font-${fontNameForEvents.replace(/\s/g, '-')}`;
    eventStyle =
      event.isAllDay || event.multiDayTimed
        ? { ...eventStyle, backgroundColor: color }
        : eventStyle;
    return connectDragSource(
      <div onClick={this.handleOnClick} className={className} style={eventStyle}>
        {showSummary &&
          (event.isAllDay ? (
            <span className="event-text" style={spanStyle}>
              {event.summary}
            </span>
          ) : (
            [
              <span className="event-time" key="a" style={spanStyle}>
                {onlyTime(event.startInZone)}
              </span>,
              <span className="event-text" key="b" style={spanStyle}>
                {event.summary}
              </span>,
            ]
          ))}
      </div>
    );
  }
}

StyledEvent.propTypes = {
  event: propTypes.object,
  style: propTypes.object,
  className: propTypes.string,
  setCurrentEvent: propTypes.func,
  showSummary: propTypes.bool,
  clickBehavior: propTypes.func,
  connectDragSource: propTypes.func,
  isDragging: propTypes.bool,
  calendars: propTypes.array,
  fontNameForEvents: propTypes.string,
};

StyledEvent.defaultProps = {
  style: {},
  showSummary: true,
};
